import React from 'react';

import { Controller } from 'react-hook-form';

import {
    useJournalEventsSearch,
    useJournalSearchForm,
} from '@features/JournalEventsSearch/lib/hooks';
import { Icon, Input, Skeleton } from '@shared/ui';

import cls from './JournalEventsSearch.module.css';

export const JournalEventsSearch = ({ isPending }: { isPending: boolean }) => {
    const { t } = useJournalEventsSearch();
    const { handleKeyDown, handleBlur, control, errors } = useJournalSearchForm();

    if (isPending) {
        return <Skeleton width="100%" height={28} border="8px" />;
    }

    return (
        <Controller
            name="search"
            control={control}
            rules={{
                maxLength: {
                    value: 128,
                    message: t('JournalEvents.JournalEventsSearch.Input.Error.MaxLength'),
                },
            }}
            render={({ field }) => (
                <Input
                    {...field}
                    inputClassName={cls.Input}
                    leftIcon={<Icon iconName="search" height={16} width={16} />}
                    onKeyDown={handleKeyDown}
                    onBlur={handleBlur}
                    placeholder={t('JournalEvents.JournalEventsSearch.Input.placeholder')}
                    error={errors?.search?.message}
                />
            )}
        />
    );
};
